/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { ICache, RequestCache } from '@msdyn365-commerce/cache-internal';
import {
    IAny,
    IExperimentationConnector,
    IGeneric,
    IRequestContext,
    MSDyn365Commerce,
    msdyn365Commerce
} from '@msdyn365-commerce/core-internal';
import { initializeApp } from './initialization';
import { IBinding, IMSDyn365CommerceWithPrototype } from './models';
import { createComponent } from './render-component';

interface IConnectors {
    experimentation: IExperimentationConnector;
}

const requestCache: ICache = new RequestCache();

export const initializeClientApp = (bindings: IBinding, connectors: IConnectors) => {
    initializeApp(bindings);

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.updatePrivateVariable = function(): void {
        const appDatabv = (<any>window).___appData___ && (<any>window).___appData___.bv;

        // @ts-ignore -- accessing a private class variable which is a valid JS
        this._buildVersion = appDatabv;

        this.createComponent = createComponent;

        // @ts-ignore -- accessing a private class variable which is a valid JS
        this._experimentationConnector = connectors?.experimentation;

        // @ts-ignore -- accessing a private class variable which is a valid JS
        this._platformSettings = (<any>window).___initialData___ && (<any>window).___initialData___._clientPlatformSetting;
    };

    (<IGeneric<IAny>>msdyn365Commerce).updatePrivateVariable();

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.getAppCache = (requestContext: IRequestContext) => requestCache;
};
